import { NavLink } from "react-router-dom";
import { ChevronsRight, LogOut, RadioTower, Settings, UserRound } from "lucide-react";
import RoleSwitcher from "./RoleSwitcher";
import { APP_VERSION, APP_BUILD_AT } from "../version";

export const SidebarFooter = ({ user, collapsed, onExpand, onNavigate, onLogout, bulletinCount, backendVersion }) => (
  <footer className={`sidebar-footer ${collapsed ? "is-collapsed" : ""}`} data-testid="sidebar-footer">
    {collapsed ? (
      <button onClick={onExpand} title="Expand sidebar" aria-label="Expand sidebar" data-testid="expand-sidebar-btn">
        <ChevronsRight size={18} />
      </button>
    ) : (
      <>
        <div className="sidebar-identity" data-testid="sidebar-signed-in-as">
          <UserRound size={18} aria-hidden="true" />
          <div className="min-w-0">
            <span className="sidebar-caption">Signed in as</span>
            <strong data-testid="sidebar-user-name">{user.name}</strong>
          </div>
        </div>
        <RoleSwitcher user={user} />
      </>
    )}
    <div className="sidebar-footer-actions">
      <NavLink to="/settings" onClick={onNavigate} title="Settings" aria-label="Settings" data-testid="nav-settings">
        <Settings size={17} />{!collapsed && <span>Settings</span>}
      </NavLink>
      <NavLink to="/bulletins" onClick={onNavigate} title="Bulletins" aria-label="Bulletins" data-testid="nav-bulletins">
        <RadioTower size={17} />{!collapsed && <span>Bulletins</span>}
        {bulletinCount > 0 && <span className="sidebar-bulletin-count" data-testid="nav-bulletins-badge">{bulletinCount}</span>}
      </NavLink>
      <button onClick={onLogout} title="Sign out" aria-label="Sign out" data-testid="logout-btn">
        <LogOut size={17} />{!collapsed && <span>Sign out</span>}
      </button>
    </div>
    {!collapsed && <span className="sidebar-caption" data-testid="sidebar-app-version" title={`Frontend v${APP_VERSION}${backendVersion ? ` · Backend v${backendVersion}` : ""}${APP_BUILD_AT ? ` · Built ${APP_BUILD_AT}` : ""}`}>v{APP_VERSION}</span>}
  </footer>
);